module.exports = __webpack_public_path__ + "img/Expensify.0ea3e5c8.svg";